import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { WagmiWrp } from './components/WagmiWrp';
import './assets/styles/styles.scss';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

if (process.env.NODE_ENV !== 'development') {
  console.log = () => {};
}

const GOOGLECLIENTID =
    '1025891271764-mmvijafb4dc1d3gclpq117om5h8al8ub.apps.googleusercontent.com';

root.render(
  <BrowserRouter>
    <WagmiWrp>
        <GoogleOAuthProvider clientId={GOOGLECLIENTID}>
      <App />
        </GoogleOAuthProvider>
    </WagmiWrp>
  </BrowserRouter>,
);

reportWebVitals();
